var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamBronze2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 240,
    width: 160,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "team_bronze_2_svg__a",
    cx: 63,
    cy: 83,
    r: 57
  }), /*#__PURE__*/React.createElement("mask", {
    id: "team_bronze_2_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fillRule: "evenodd",
    xlinkHref: "#team_bronze_2_svg__a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 43)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6f472f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 120h58v36l-29 19.44L34 156zM12 11.215C24 3.738 40.833 0 62.5 0S101 3.738 113 11.215l-10 43H22z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 83,
    r: 63
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#3d2719",
    xlinkHref: "#team_bronze_2_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.002 97.067c-.61-.51-1.478-1.094-2.603-1.748.311-1.474.57-2.5.777-3.075s.531-1.181.975-1.814c-3.796.61-6.706.738-8.732.384-2.026-.353-4.339-1.391-6.937-3.115l-5.847-5.688c.686 7.648 1.27 12.776 1.753 15.385.64 3.463 1.96 8.22 2.426 10.316.995 4.48 1.853 8.28 2.573 11.4l-.905.888-.083-.042c-.505-.257-3.222-1.711-5.935-4.504-.993-1.023-2.349-2.969-4.067-5.838C33.466 102.594 33 97.323 33 93.803s.466-8.388 1.397-14.604L33 77.444c.654-.68 1.015-1.188 1.083-1.526.476-2.366-.021-4.194 0-5.328.085-4.557-.247-9.136.738-12.394 1.432-4.733 4.042-8.848 7.83-12.344 3.426-2.31 6.207-3.929 8.343-4.858C53.13 40.064 57.132 39.4 63 39l.528.037c5.581.403 9.407 1.056 11.478 1.957 2.136.929 4.917 2.548 8.343 4.858 3.788 3.496 6.398 7.61 7.83 12.344.985 3.258.653 7.837.738 12.394.021 1.134-.476 2.962 0 5.328.068.338.429.847 1.083 1.526L91.603 79.2C92.534 85.415 93 90.283 93 93.803s-.466 8.79-1.397 15.813c-1.718 2.87-3.074 4.815-4.067 5.838-2.713 2.793-5.43 4.247-5.935 4.504l-.083.042-.905-.888c.72-3.12 1.578-6.92 2.573-11.4.465-2.095 1.786-6.853 2.426-10.316.482-2.609 1.067-7.737 1.753-15.385l-5.847 5.688c-2.598 1.724-4.91 2.762-6.937 3.115-2.026.354-4.936.226-8.732-.384.444.633.769 1.237.975 1.814s.466 1.6.777 3.075c-1.125.654-1.993 1.237-2.603 1.748s-1.276.894-1.998 1.148a6.414 6.414 0 01-1.998-1.148zM48 70.547c-1.442.405-2.777 1.179-4.005 2.321-.283 1.47-.283 2.624 0 3.46.199.583 1.507 2.386 3.344 3.69 2.107 1.496 4.85 2.495 6.401 2.95a17.4 17.4 0 005.807.705V75.78c-.328-1.517-.798-2.635-1.411-3.353-.39-.457-1.904-2.158-3.66-2.556-2.384-.539-5.23.326-6.476.676zm30 0c-1.245-.35-4.092-1.215-6.476-.676-1.756.398-3.27 2.1-3.66 2.556-.613.718-1.083 1.836-1.411 3.353v7.893a17.4 17.4 0 005.807-.705c1.551-.455 4.294-1.454 6.401-2.95 1.837-1.304 3.145-3.107 3.344-3.69.283-.836.283-1.99 0-3.46-1.228-1.142-2.563-1.916-4.005-2.32z",
    fill: "#ffa672",
    mask: "url(#team_bronze_2_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ffa672"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101 13l15 21-15 21-15-21zM59 13l15 21-15 21-15-21z"
  })))));
}
export default SvgTeamBronze2;